import { BadgeIconStateType } from '../types/badgeIconStateType';
export const getBadgeIconState = ({ disabled }) => {
    if (disabled) {
        return BadgeIconStateType.DISABLED;
    }
    return BadgeIconStateType.DEFAULT;
};
//# sourceMappingURL=state.js.map